import axios from "axios";
import { BASE_URL } from "constants/api";
import { LocalStorage } from "enums/localStorage";
import { getRefreshToken } from "framework/auth";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken: string | null = localStorage.getItem(
      LocalStorage.ACCESS_TOKEN
    );
    if (accessToken) config.headers!.Authorization = `Bearer ${accessToken}`;

    return config;
  },
  (error) => {
    console.error(error);
    // Do something with request error
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    // Handle successful responses
    return response;
  },
  async (error) => {
    const originalConfig = error.config;

    if (error.response) {
      if (error.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;
        try {
          // Refresh the token
          const {data} = await getRefreshToken();
          const { accessToken, refreshToken } = data 
          // Store the new tokens
          localStorage.setItem(LocalStorage.ACCESS_TOKEN, accessToken);
          localStorage.setItem(LocalStorage.REFRESH_TOKEN, refreshToken);

          // Retry the original request with new access token
          return axiosInstance(originalConfig);
        } catch (refreshError) {
          localStorage.clear();
          window.location.href = "/login";
          return Promise.reject(refreshError);
        }
      }

      if (error.response.status === 403 && error.response.data) {
        return Promise.reject(error.response.data);
      }

      return Promise.reject(error);
    } else {
      if (!originalConfig._retry) {
        originalConfig._retry = true;
        try {
          // Refresh the token
          const { data } = await getRefreshToken();
          const { accessToken, refreshToken } = data
          // Store the new tokens
          localStorage.setItem(LocalStorage.ACCESS_TOKEN, accessToken);
          localStorage.setItem(LocalStorage.REFRESH_TOKEN, refreshToken);
          // Update the Authorization header
          axiosInstance.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${accessToken}`;
          originalConfig.headers["Authorization"] = `Bearer ${accessToken}`;

          // Retry the original request with new access token
          return axiosInstance(originalConfig);
        } catch (refreshError) {
          localStorage.clear();
          window.location.href = "/login";
          return Promise.reject(refreshError);
        }
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
